import React, { Component } from 'react';
import { reduxForm, SubmissionError } from 'redux-form';
import AlbumValidator from '../../validators/AlbumValidator'
import InputField from '../Inputs/InputField'


class AlbumForm extends Component {
    constructor(props) {
	super(props);
	this.state = {
	    waiting: false,
	    authorized: undefined
	}
    }
 
    
    render() {
	const { handleSubmit, successAction } = this.props
	let {waiting} = this.state
	
	const submit = (values, dispatch, props) => {
	    let errors = AlbumValidator( values, props ) || {};
	    waiting=true
	    this.setState({waiting})
	    if (Object.keys(errors).length) {
		throw new SubmissionError(errors);
	    } else {
		let saveAction = values.id ? props.updateAlbum : props.saveAlbum	
		saveAction(values).then((res) => {
		    waiting=false
		    this.setState({waiting})
		    props.reset()
		    successAction()
		}).catch((err) => {
		    waiting=false
		    this.setState({waiting})
		    console.log(err)})
	    }
	}

	

	return (

	    <form onSubmit={handleSubmit(submit)}>		
		<InputField name="name" type="text" label="Ime" />

		<button type="submit" disabled={this.props.invalid || waiting} className="btn btn-brown btn-big full-width" >
		    <i style={{display: (waiting ? 'inline-block' : 'none' )}} className="fa fa-spinner fa-spin"></i>
		    {
			this.props.invalid ?
			'Pomankljivosti v unosu podtkov poglej zgoraj'
			:
			'Sharni'
		    }
		</button>
	    </form>
	);
    }
}

export default reduxForm({
    form: 'album',
    validate: AlbumValidator,
    enableReinitialize: true
})(AlbumForm);



// WEBPACK FOOTER //
// ./src/components/AlbumForm/index.jsx